import { FC } from "react";
import CategoryStatusTable from "../CategoryStatusTable";
import useBusinessTripReportsCategoryStatus, {
  Props,
  ReceivedProps,
} from "./hook";
import { Styles } from "./styled";

const BusinessTripReportsCategoryStatusLayout: FC<Props> = () => {
  return (
    <Styles>
      <CategoryStatusTable
        screen="business_trip_reports"
        recordType="status"
        nonEditable
      />
      <CategoryStatusTable
        screen="business_trip_reports"
        recordType="category"
      />
    </Styles>
  );
};

const BusinessTripReportsCategoryStatus: FC<ReceivedProps> = (props) => (
  <BusinessTripReportsCategoryStatusLayout
    {...useBusinessTripReportsCategoryStatus(props)}
  />
);

export default BusinessTripReportsCategoryStatus;
